import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCards0 from "./ProjectCards0";
import ProjectCards1 from "./ProjectCards1";
import ProjectCards2 from "./ProjectCards2";
import Particle from "../Particle";
import img1 from "../../Assets/Projects/img1.png";
import img2 from "../../Assets/Projects/img2.png";
import img3 from "../../Assets/Projects/img3.png";



function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Martian <strong className="purple">Inventions </strong>
        </h1>
        <p style={{ color: "white" }}>
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCards0
              imgPath={img1}
              isBlog={false}
              title="Rockets"
              ghLink="https://patents.google.com/patent/US20220234765A1/en"
              ghLink1="https://patents.google.com/patent/US20230249847A1/en"
              description="U.S. Patent Application No. 18,672,666"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards1
              imgPath={img2}
              isBlog={false}
              title="Satellites"
              description="U.S. Patent Application No. 17,980,823"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards2
              imgPath={img3}
              isBlog={false}
              title="Missiles"
              description="U.S. Patent Application No. 18,764,352"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
